import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout/Layout';
import { Login } from './pages/Login/Login';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { MembersList } from './pages/Members/MembersList';
import { MemberForm } from './pages/Members/MemberForm';
import { MemberView } from './pages/Members/MemberView';
import { ExpenseForm } from './pages/Expenses/ExpenseForm';
import { DuesList } from './pages/Dues/DuesList';
import { AccountingDashboard } from './pages/Accounting/AccountingDashboard';
import { BudgetOverview } from './pages/Budget/BudgetOverview';
import { ReportsCenter } from './pages/Reports/ReportsCenter';
import { basePath } from './config/api';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="members" element={<MembersList />} />
        <Route path="members/new" element={<MemberForm />} />
        <Route path="members/:id" element={<MemberView />} />
        <Route path="members/:id/edit" element={<MemberForm />} />
        <Route path="expenses" element={<ExpenseForm />} />
        <Route path="expenses/new" element={<ExpenseForm />} />
        <Route path="dues" element={<DuesList />} />
        <Route path="accounting" element={<AccountingDashboard />} />
        <Route path="budget" element={<BudgetOverview />} />
        <Route path="reports" element={<ReportsCenter />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter basename={basePath}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;